module.exports = __webpack_public_path__ + "img/icon_hege.a5f9b6dd.png";